import Vue from 'vue';
import axios from 'axios';
import { Message } from 'element-ui';
import Cookies from 'js-cookie';
import store from '@/store';
import router from '@/router';
import { getCurrentToken, isGuestToken } from '@/utils/guestToken';

// 创建 axios 实例
const service = axios.create({
  // baseURL: process.env.VUE_APP_API_URL, // api 的 base_url
  timeout: 60000 // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 优先使用用户token,如果没有则使用游客token
    let token = getCurrentToken();
    let userid = localStorage.getItem('userid');
    let lang = Cookies.get('locale')
    
    if (token) {
      config.headers['token'] = token;
      
      // 如果是游客token,添加特殊标识
      if (isGuestToken(token)) {
        config.headers['token'] = token;
      } else {
        config.headers['userid'] = userid;
      }
    }
    if (lang) {
      config.headers['language'] = lang;
    } else {
      config.headers['language'] = '2';
    }
    config.headers['system'] = '2';
    config.headers['Form-type'] = 'pc';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    let res = response.data;
    switch (res.code) {
      case 200:
        return res;
      case 400:
        Message.error(res.msg || '参数校验失败');
        return Promise.reject(res);
      case 403:
        Message.error(res.msg || '没有相关权限');
        return Promise.reject(res);
      case 404:
        Message.error(res.msg || '没有找到相关数据');
        return Promise.reject(res);
      case 500:
        Message.error(res.msg || '系统异常');
        return Promise.reject(res);
      case 401:
      case 410000:
      case 410001:
      case 410002:
        Cookies.set('fromPath', router.currentRoute.fullPath);
        localStorage.clear();
        store.commit('SET_USER_INFO', {})
        if (router.currentRoute.path !== '/') {
          store.commit('isLogin', true);
          Message.error(res.msg);
        }
        return Promise.reject(res);
      default:
        Message.error(res.msg);
        return Promise.reject(res);
    }
  },
  (error) => {
    Message.error(error.msg);
    return Promise.reject(error);
  }
);

Vue.prototype.$axios = service;

export default service;
